import { useSkaldElements } from '@skaldaura/devkit'
import { translation } from 'I18n/i18n'
import { IPopulatedCatalogue } from 'components/catalogue/catalogue'
import { P } from 'components/myTags/myTags'
import PagesReader from 'components/pagesReader/pagesReader'
import HTMLReactParser from 'html-react-parser'
import englishCondition from 'pages/visiteur/englishAssert'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Popup from 'reactjs-popup'
import { Colors } from 'styles/colors'

interface IProps {
   visiteur?: boolean
}

export default function SolutionResine(props: IProps) {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const [elements, fetchingOver] = useSkaldElements(englishCondition(lang, props.visiteur) ? "Sustainable resin solutions" : "Solutions durables en résine")
   const [pages, setPages] = useState<string[]>([])
   const [open, setOpen] = useState(false)

   const closeModal = () => setOpen(false)
   const openModal = () => setOpen(true)

   useEffect(() => {
      if (fetchingOver && elements.length > 0) {
         elements[0].getPopulatedSubgroups("Catalogue")
            .then((catalogue: IPopulatedCatalogue[]) => catalogue.length > 0 && catalogue[0] && catalogue[0].pages && setPages(catalogue[0].pages.map((page) => page.value)))
      }
   }, [elements])

   return (
      <div className='flex column' style={{ background: 'white', height: '1300px', position: "relative" }}>
         <br />
         <P fontSize={'22px'} color={Colors.corail}>
            {HTMLReactParser(translation(lang, 'environnement', 'bloc1Txt1'))}
         </P>
         <br />
         <div>
            <Popup
               trigger={
                  <img
                     src={pages.length > 0 ? pages[0] : ""}
                     style={{
                        border: `1px ${Colors.black} solid`,
                        marginTop: '50px',
                        width: '500px',
                     }}
                     alt=''
                  />
               }
               modal
               closeOnDocumentClick
               open={open}
               onClose={closeModal}
               onOpen={openModal}
            >
               {<PagesReader pages={pages} close={closeModal} />}
            </Popup>
            <img src={`/finger-white.png`} alt='' className='finger-white' style={{
               backgroundColor: Colors.bleu,
               height: "65px",
               padding: "10px",
               borderRadius: "100px",
               position: "absolute",
               bottom: "-25px",
               right: "30px"
            }} />
         </div>
         <br />
         <br />
      </div>
   )
}
